import React, { useState } from "react";
import { Form, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import ErrorPopup from "../Shared/ErrorPopup";
import axios from "axios";

const UserLogin = () => {
  const navigate = useNavigate();

  // Error modal
  const [openPopup, setOpenPopup] = useState(false);
  const [error, setError] = useState("");

  const checkLogin = () => {
    const api = document.getElementById("formApiKey").value;

    axios
      .post("api/Login/CheckKeyTenant", {
        key: api,
      })
      .then((response) => {
        const value = response.data.successful.value;
        if (value === true) {
          axios
            .get("api/Tenant/GetTenantId/" + api)
            .then((response) => {
              var tenantId = response.data.tenantID;
              var data = { apiKey: api, tenantId: tenantId };
              var storage = localStorage.setItem(
                "Tenant_info",
                JSON.stringify(data)
              );
              navigate("/Dashboard/" + api);
            })
            .catch(function (error) {
              console.log("Tenant Id error");
            });
        } else {
          setError("Probeer nog maals");
          setOpenPopup(true);
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  return (
    <>
      <Card>
        <Card.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formApiKey">
              <Form.Label>API Key</Form.Label>
              <Form.Control type="text" />
            </Form.Group>

            <Button onClick={checkLogin} variant="primary">
              Login
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <ErrorPopup open={openPopup} onHide={() => setOpenPopup(false)}>
        {error}
      </ErrorPopup>
    </>
  );
};

export default UserLogin;
